import { render, staticRenderFns } from "./ThermalTest.vue?vue&type=template&id=f6adc680&"
import script from "./ThermalTest.vue?vue&type=script&lang=js&"
export * from "./ThermalTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports